import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

const AppDevelopment = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Breadcrumb Section */}
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    App <span className="breadcrumb-highlight">Development</span>
                                </h1>
                                <Link to="/services" style={{ textDecoration: 'none' }}>
                                    <button className="breadcrumb-btn">
                                        <span>Our Services</span>
                                        <span className="breadcrumb-arrow">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Hero Section */}
            <section className="digital-presence-hero">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <div className="hero-badge">
                                <span className="badge-dot"></span>
                                Leading Mobile App Development Company
                            </div>
                            <h2 className="intro-about-heading">
                                Transform Ideas Into
                                <span className="text-gradient"> Powerful Mobile Apps</span>
                            </h2>
                            <p className="hero-description" style={{ color: '#3c3a3aff' }}>
                                Bring your vision to life with <span className="text-blue-highlight">innovative mobile solutions</span> that engage users and drive business growth. From concept to launch, we craft apps that make an impact.
                            </p>
                            <div className="hero-buttons">
                                <button className="btn-hero-secondary">
                                    View Our Work →
                                </button>
                            </div>
                            <div className="hero-stats">
                                <div className="stat-card">
                                    <h3 className="stat-number">500+</h3>
                                    <p className="stat-label">Apps Developed</p>
                                </div>
                                <div className="stat-card">
                                    <h3 className="stat-number">10M+</h3>
                                    <p className="stat-label">Active Users</p>
                                </div>
                                <div className="stat-card">
                                    <h3 className="stat-number">4.8/5</h3>
                                    <p className="stat-label">Average Rating</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="hero-image-container">
                                <img src={require('../../assets/images/Mobile-App-Development.png')} alt="App Development Hero" className="img-fluid rounded shadow-md" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Comprehensive App Development Solutions Section */}
            <section className="comprehensive-design-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Our Expertise
                        </div>
                        <h2 className="comprehensive-title">
                            End-to-End App Development Services
                        </h2>
                        <p className="comprehensive-subtitle">
                            Complete solutions for iOS, Android, and Cross-Platform applications
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Native iOS Development */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📱</span>
                                </div>
                                <h3 className="solution-card-title">Native iOS Development</h3>
                                <p className="solution-card-description">
                                    Premium iOS apps built with Swift and Objective-C for optimal performance and seamless Apple ecosystem integration
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Native Android Development */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🤖</span>
                                </div>
                                <h3 className="solution-card-title">Native Android Development</h3>
                                <p className="solution-card-description">
                                    Robust Android applications using Kotlin and Java, optimized for diverse device configurations
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Cross-Platform Apps */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card highlighted">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">⚡</span>
                                </div>
                                <h3 className="solution-card-title">Cross-Platform Apps</h3>
                                <p className="solution-card-description">
                                    Cost-effective solutions with React Native and Flutter - one codebase for iOS and Android
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* UI/UX Design */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🎨</span>
                                </div>
                                <h3 className="solution-card-title">UI/UX Design</h3>
                                <p className="solution-card-description">
                                    Beautiful, intuitive interfaces that enhance user engagement and satisfaction
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* App Maintenance & Support */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔧</span>
                                </div>
                                <h3 className="solution-card-title">Maintenance & Support</h3>
                                <p className="solution-card-description">
                                    Ongoing updates, bug fixes, and feature enhancements to keep your app running smoothly
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* App Testing & QA */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">✅</span>
                                </div>
                                <h3 className="solution-card-title">Testing & QA</h3>
                                <p className="solution-card-description">
                                    Comprehensive testing across devices ensuring bug-free, high-quality app experiences
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-5">
                        <button className="btn-start-project">
                            Start Your App Project →
                        </button>
                    </div>
                </div>
            </section>

            {/* Why Choose Profit Technologies */}
            <section className="bespoke-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <h2 className="section-main-title mb-4">
                                Why Choose Profit Technologies for App Development?
                            </h2>
                            <p className="section-description">
                                <strong>Your Trusted Partner in Mobile Innovation</strong>
                            </p>
                            <p className="section-description">
                                At <strong>Profit Technologies</strong>, we don't just build apps – we create digital experiences that transform businesses. With years of expertise in mobile app development, our team of skilled developers, designers, and strategists work collaboratively to deliver solutions that exceed expectations.
                            </p>
                            <p className="section-description">
                                From startups to enterprises, we've helped businesses across industries launch successful mobile applications that drive user engagement, boost revenue, and establish strong market presence. Our agile approach ensures timely delivery without compromising quality.
                            </p>
                            <p className="section-description">
                                <strong>What sets us apart:</strong>
                            </p>
                            <ul className="section-description" style={{ paddingLeft: '20px' }}>
                                <li>✓ Expert team with 10+ years of mobile development experience</li>
                                <li>✓ Proven track record of 500+ successful app launches</li>
                                <li>✓ Latest technology stack and best practices</li>
                                <li>✓ Transparent communication and agile methodology</li>
                                <li>✓ Post-launch support and continuous improvement</li>
                                <li>✓ Competitive pricing with no hidden costs</li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <div className="bespoke-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&q=80"
                                    alt="Profit Technologies App Development"
                                    className="img-fluid rounded"
                                    style={{ boxShadow: '0 10px 40px rgba(0,0,0,0.1)' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Technologies We Use */}
            <section className="comprehensive-design-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Tech Stack
                        </div>
                        <h2 className="comprehensive-title">
                            Technologies We Master
                        </h2>
                        <p className="comprehensive-subtitle">
                            Leveraging cutting-edge technologies for superior app development
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* React Native */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">⚛️</span>
                                </div>
                                <h3 className="solution-card-title">React Native</h3>
                                <p className="solution-card-description">
                                    Build powerful cross-platform apps with native performance
                                </p>
                            </div>
                        </div>

                        {/* Flutter */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🎯</span>
                                </div>
                                <h3 className="solution-card-title">Flutter</h3>
                                <p className="solution-card-description">
                                    Beautiful, fast apps for any platform with single codebase
                                </p>
                            </div>
                        </div>

                        {/* Swift */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🍎</span>
                                </div>
                                <h3 className="solution-card-title">Swift</h3>
                                <p className="solution-card-description">
                                    Native iOS development for premium Apple experiences
                                </p>
                            </div>
                        </div>

                        {/* Kotlin */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">💚</span>
                                </div>
                                <h3 className="solution-card-title">Kotlin</h3>
                                <p className="solution-card-description">
                                    Modern Android development with concise, safe code
                                </p>
                            </div>
                        </div>

                        {/* Firebase */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔥</span>
                                </div>
                                <h3 className="solution-card-title">Firebase</h3>
                                <p className="solution-card-description">
                                    Real-time database, authentication, and cloud functions
                                </p>
                            </div>
                        </div>

                        {/* Node.js */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🟢</span>
                                </div>
                                <h3 className="solution-card-title">Node.js</h3>
                                <p className="solution-card-description">
                                    Scalable backend APIs for mobile applications
                                </p>
                            </div>
                        </div>

                        {/* AWS */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">☁️</span>
                                </div>
                                <h3 className="solution-card-title">AWS</h3>
                                <p className="solution-card-description">
                                    Cloud infrastructure for reliable, scalable apps
                                </p>
                            </div>
                        </div>

                        {/* GraphQL */}
                        <div className="col-lg-3 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔷</span>
                                </div>
                                <h3 className="solution-card-title">GraphQL</h3>
                                <p className="solution-card-description">
                                    Efficient data querying for modern mobile apps
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Development Process */}
            <section className="comprehensive-design-section py-5" style={{ backgroundColor: '#ffffff' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Our Process
                        </div>
                        <h2 className="comprehensive-title">
                            How We Build Your App
                        </h2>
                        <p className="comprehensive-subtitle">
                            A proven methodology that ensures success from concept to launch
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Discovery & Planning */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🔍</span>
                                </div>
                                <h3 className="solution-card-title">1. Discovery & Planning</h3>
                                <p className="solution-card-description card-text-dst">
                                    Understanding your vision, analyzing requirements, and creating a detailed roadmap for success
                                </p>
                            </div>
                        </div>

                        {/* Design & Prototyping */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🎨</span>
                                </div>
                                <h3 className="solution-card-title">2. Design & Prototyping</h3>
                                <p className="solution-card-description card-text-dst">
                                    Creating wireframes, mockups, and interactive prototypes to visualize your app
                                </p>
                            </div>
                        </div>

                        {/* Development */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">💻</span>
                                </div>
                                <h3 className="solution-card-title">3. Development</h3>
                                <p className="solution-card-description card-text-dst">
                                    Agile sprints with regular updates, building robust features with clean, scalable code
                                </p>
                            </div>
                        </div>

                        {/* Testing & QA */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🧪</span>
                                </div>
                                <h3 className="solution-card-title">4. Testing & QA</h3>
                                <p className="solution-card-description card-text-dst">
                                    Rigorous testing across devices, platforms, and scenarios to ensure flawless performance
                                </p>
                            </div>
                        </div>

                        {/* Launch */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🚀</span>
                                </div>
                                <h3 className="solution-card-title">5. Launch</h3>
                                <p className="solution-card-description card-text-dst">
                                    App Store and Play Store submission, optimization, and successful market release
                                </p>
                            </div>
                        </div>

                        {/* Support & Growth */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📈</span>
                                </div>
                                <h3 className="solution-card-title">6. Support & Growth</h3>
                                <p className="solution-card-description card-text-dst">
                                    Continuous monitoring, updates, and feature enhancements based on user feedback
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AppDevelopment;